import { render, staticRenderFns } from "./DirImageView.vue?vue&type=template&id=e13b9d22&scoped=true&"
import script from "./DirImageView.vue?vue&type=script&lang=js&"
export * from "./DirImageView.vue?vue&type=script&lang=js&"
import style0 from "./DirImageView.vue?vue&type=style&index=0&id=e13b9d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13b9d22",
  null
  
)

export default component.exports